module.exports = "<div class=\"row admin-site-section\">\n  <div class=\"admin-site-menu-section\">\n    <app-admin-site-menu></app-admin-site-menu>\n  </div>\n  <div class=\"admin-site-viwer\">\n    <div class=\"view-admin-section\">\n      <router-outlet (activate)=\"onActivate($event)\"></router-outlet>\n    </div>\n  </div>\n</div>\n\n\n\n\n\n\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/admin-site/admin-site.component.html
// module id = ../../../../../src/app/pages/admin/admin-site/admin-site.component.html
// module chunks = main